import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import eimg from '../Images/rebar.jpg';
import excel from '../Images/excel.jpg'
import asa from '../Images/asa1.jpg';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp, faInstagram, faFacebook, faLinkedin } from "@fortawesome/free-brands-svg-icons";

import homeEstimation1 from "../Images/homeEstimation1.png";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { Link } from 'react-router-dom';




export default function Home() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();

  // Background slideshow

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  // Validation
  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = 'Name is required';
    if (!form.phone.trim()) errs.phone = 'Phone number is required';
    if (!form.email.trim()) {
      errs.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      errs.email = 'Enter a valid email';
    }
    if (!form.message.trim()) errs.message = 'Message is required';
    return errs;
  };

  // Handle form input
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle form submit (EmailJS)
  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length === 0) {
      setErrors({});
      setSubmitted(false);
      setErrorMsg('');

      emailjs
        .send(
          'service_pbgoiql',    // ✅ Replace with your EmailJS Service ID
          'template_z395lk6',   // ✅ Replace with your Template ID
          form,
          'm2R65_Wa7RGzc2dvb'   // ✅ Replace with your Public Key
        )
        .then(() => {
          setSubmitted(true);
          setForm({ name: '', phone: '', email: '', message: '' });
        })
        .catch(() => {
          setErrorMsg('Failed to send message. Try again.');
        });
    } else {
      setErrors(errs);
      setSubmitted(false);
    }
  };

  return (


    <div className="home-page">
      <section
        className="relative min-h-screen bg-cover bg-center"
        style={{ backgroundImage: `url(${homeEstimation1})` }}
      >
        <div className="absolute inset-0 bg-slate-950/45"></div>

        <div className="relative z-10 flex items-center min-h-screen">

          <div className="max-w-7xl mx-auto w-full px-6 lg:px-8">

            <div className="grid lg:grid-cols-2 gap-20 items-center">

              {/* LEFT */}

              <div>

                <span className="inline-flex px-4 py-2 rounded-full bg-orange-500 text-white font-medium">
                  Since 2019
                </span>

                <h1 className="mt-8 text-6xl lg:text-7xl font-bold text-white leading-tight">
                  Welcome to
                  <span className="block text-sky-400">
                    EDRS
                  </span>
                </h1>

                <h2 className="mt-5 text-2xl text-white font-medium">
                  Professional Rebar Estimation Services
                </h2>

                <p className="mt-8 text-lg text-slate-200 leading-8 max-w-xl">
                  Delivering accurate reinforcing steel quantity take-offs
                  for commercial, residential, industrial and infrastructure
                  construction projects across the United States.
                </p>

                <div className="flex flex-wrap gap-4">

                  <Link
                    to="/contact"
                    className="bg-orange-500 hover:bg-orange-600 px-8 py-4 rounded-lg text-white font-semibold transition duration-300"
                  >
                    Request Quote
                  </Link>

                  <Link
                    to="/services/rebar-estimation"
                    className="border border-white px-8 py-4 rounded-lg text-white hover:bg-white hover:text-slate-900 transition duration-300"
                  >
                    Our Services
                  </Link>

                </div>

              </div>

              {/* RIGHT */}

              {/* ================= RIGHT ================= */}

              <div className="flex justify-center lg:justify-end">

                <div
                  ref={ref}
                  className="
    w-full
    max-w-md
    rounded-3xl
    bg-white/5
    backdrop-blur-sm
    border border-white/25
    shadow-2xl
    p-8
    transition-all
    duration-500
    hover:bg-white/10
    hover:-translate-y-2
  "
                >

                  {/* Header */}

                  <div className="mb-8">

                    <span className="text-sky-300 uppercase tracking-[4px] text-sm font-semibold">
                      EDRS
                    </span>

                    <h3 className="mt-2 text-3xl font-bold text-white">
                      Company Highlights
                    </h3>

                    <p className="mt-3 text-gray-200 leading-7">
                      Delivering professional rebar estimation services with
                      precision, quality and reliability.
                    </p>

                  </div>

                  {/* ================= Statistics ================= */}

                  <div className="space-y-5">

                    {/* Projects */}

                    <div className="flex items-center justify-between rounded-2xl border border-white/10 bg-white/5 px-5 py-5">

                      <div className="flex items-center gap-4">

                        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-orange-500/20 text-2xl">
                          📁
                        </div>

                        <div>

                          <h4 className="font-semibold text-white">
                            Projects Completed
                          </h4>

                          <p className="text-sm text-gray-300">
                            Successfully Delivered
                          </p>

                        </div>

                      </div>

                      <div className="text-right">

                        <h2 className="text-4xl font-bold text-orange-400">

                          {inView && (
                            <>
                              <CountUp
                                start={0}
                                end={600}
                                duration={2.5}
                              />
                              +
                            </>
                          )}

                        </h2>

                      </div>

                    </div>

                    {/* Tons */}

                    <div className="flex items-center justify-between rounded-2xl border border-white/10 bg-white/5 px-5 py-5">

                      <div className="flex items-center gap-4">

                        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-sky-500/20 text-2xl">
                          🏗️
                        </div>

                        <div>

                          <h4 className="font-semibold text-white">
                            Tons Estimated
                          </h4>

                          <p className="text-sm text-gray-300">
                            Reinforcing Steel
                          </p>

                        </div>

                      </div>

                      <div className="text-right">

                        <h2 className="text-4xl font-bold text-sky-400">

                          {inView && (
                            <>
                              <CountUp
                                start={0}
                                end={60000}
                                duration={3}
                                separator=","
                              />
                              +
                            </>
                          )}

                        </h2>

                      </div>

                    </div>

                    {/* Experience */}

                    <div className="flex items-center justify-between rounded-2xl border border-white/10 bg-white/5 px-5 py-5">

                      <div className="flex items-center gap-4">

                        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-500/20 text-2xl">
                          ⭐
                        </div>

                        <div>

                          <h4 className="font-semibold text-white">
                            Years Experience
                          </h4>

                          <p className="text-sm text-gray-300">
                            Since 2019
                          </p>

                        </div>

                      </div>

                      <div className="text-right">

                        <h2 className="text-4xl font-bold text-green-400">

                          {inView && (
                            <>
                              <CountUp
                                start={0}
                                end={6}
                                duration={2}
                              />
                              +
                            </>
                          )}

                        </h2>

                      </div>

                    </div>

                  </div>

                  {/* Footer */}

                  <div className="mt-8 border-t border-white/10 pt-6">

                    <p className="text-center text-sm leading-7 text-gray-200">
                      Trusted by contractors, engineers and construction companies
                      for accurate reinforcing steel quantity take-offs across
                      residential, commercial and infrastructure projects.
                    </p>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* ================= SERVICES ================= */}

      <section className="py-24 bg-gradient-to-b from-white to-slate-50">

        <div className="max-w-7xl mx-auto px-6 lg:px-8">

          {/* Heading */}

          <div className="text-center max-w-3xl mx-auto">

            <div className="flex justify-center items-center gap-4 mb-5">
              <div className="w-16 h-[3px] bg-amber-500 rounded-full"></div>

              <span className="uppercase tracking-[5px] text-amber-500 font-semibold">
                Our Services
              </span>

              <div className="w-16 h-[3px] bg-amber-500 rounded-full"></div>
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900">
              Engineering Solutions
            </h2>

            <p className="mt-6 text-lg text-gray-600 leading-8">
              Delivering reliable rebar estimation solutions with industry-leading
              accuracy, advanced software, and experienced engineering professionals.
            </p>

          </div>

          {/* Cards */}

          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-10 mt-20">

            {/* Card 1 */}

            <div className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition duration-500">

              <div className="overflow-hidden">

                <img
                  src={eimg}
                  alt="Rebar Estimation"
                  className="h-60 w-full object-cover group-hover:scale-110 transition duration-700"
                />

              </div>

              <div className="p-8">

                <div className="w-16 h-16 rounded-2xl bg-amber-100 text-amber-600 flex items-center justify-center text-3xl mb-6">
                  🏗️
                </div>

                <h3 className="text-2xl font-bold text-slate-900">
                  Rebar Estimation
                </h3>

                <p className="mt-5 text-gray-600 leading-8">
                  Accurate reinforcing steel quantity take-offs, material
                  estimation, change orders, and project quantity verification
                  for all construction projects.
                </p>

                <button
                  onClick={() => navigate("/services/rebar-estimation")}
                  className="mt-8 text-amber-600 font-semibold hover:text-amber-700"
                >
                  Learn More →
                </button>

              </div>

            </div>

            {/* Card 2 */}

            <div className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition duration-500">

              <div className="overflow-hidden">

                <img
                  src={excel}
                  alt="Excel Estimation"
                  className="h-60 w-full object-cover group-hover:scale-110 transition duration-700"
                />

              </div>

              <div className="p-8">

                <div className="w-16 h-16 rounded-2xl bg-green-100 text-green-600 flex items-center justify-center text-3xl mb-6">
                  📊
                </div>

                <h3 className="text-2xl font-bold text-slate-900">
                  Excel Estimation
                </h3>

                <p className="mt-5 text-gray-600 leading-8">
                  Professional spreadsheet-based estimation with automated
                  calculations, quantity summaries, cost comparison,
                  and organized reporting.
                </p>

                <button
                  onClick={() => navigate("/services/excel")}
                  className="mt-8 text-green-600 font-semibold hover:text-green-700"
                >
                  Learn More →
                </button>

              </div>

            </div>

            {/* Card 3 */}

            <div className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition duration-500">

              <div className="overflow-hidden">

                <img
                  src={asa}
                  alt="aSa Software"
                  className="h-60 w-full object-cover group-hover:scale-110 transition duration-700"
                />

              </div>

              <div className="p-8">

                <div className="w-16 h-16 rounded-2xl bg-blue-100 text-blue-600 flex items-center justify-center text-3xl mb-6">
                  💻
                </div>

                <h3 className="text-2xl font-bold text-slate-900">
                  aSa Estimating
                </h3>

                <p className="mt-5 text-gray-600 leading-8">
                  Industry-leading aSa software for automated reinforcing
                  steel estimation, reports, scheduling, and accurate
                  project documentation.
                </p>

                <button
                  onClick={() => navigate("/services/asa")}
                  className="mt-8 text-blue-600 font-semibold hover:text-blue-700"
                >
                  Learn More →
                </button>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* ================= CONTACT SECTION ================= */}

      <section className="bg-gradient-to-b from-white via-slate-50 to-white py-24">

        <div className="max-w-7xl mx-auto px-6 lg:px-8">

          <div className="grid lg:grid-cols-2 gap-16 items-center">

            {/* ================= LEFT ================= */}

            <div>

              <div className="flex items-center gap-4 mb-5">

                <div className="w-16 h-[3px] bg-amber-500 rounded-full"></div>

                <span className="uppercase tracking-[5px] text-amber-500 font-semibold">
                  Contact Us
                </span>

              </div>

              <h2 className="text-5xl font-bold text-slate-900 leading-tight">
                Let's Build
                <br />

                <span className="text-blue-700">
                  Your Next Project
                </span>

              </h2>

              <p className="mt-8 text-lg text-gray-600 leading-8">
                Looking for professional rebar estimation services?
                Our experienced engineers deliver accurate quantity
                take-offs, detailed calculations, Excel estimation,
                and aSa Estimating solutions for projects of every size.
              </p>

              {/* Highlights */}

              <div className="grid grid-cols-2 gap-6 mt-10">

                <div className="flex items-center gap-3">
                  <span className="text-amber-500 text-xl">✔</span>
                  <span className="font-medium text-gray-700">
                    Fast Delivery
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <span className="text-amber-500 text-xl">✔</span>
                  <span className="font-medium text-gray-700">
                    Accurate Estimation
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <span className="text-amber-500 text-xl">✔</span>
                  <span className="font-medium text-gray-700">
                    600+ Projects
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <span className="text-amber-500 text-xl">✔</span>
                  <span className="font-medium text-gray-700">
                    60,000+ Tons
                  </span>
                </div>

              </div>

              {/* Social Icons */}

              <div className="flex gap-4 mt-12">

                <a
                  href="https://wa.me/919578726150"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 flex items-center justify-center text-white text-2xl transition shadow-lg"
                >
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>

                <a
                  href="https://www.instagram.com/narenthbe?igsh=MWhneTZuem5xc2g1cQ=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 rounded-full bg-pink-500 hover:bg-pink-600 flex items-center justify-center text-white text-2xl transition shadow-lg"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>

                <a
                  href="https://www.facebook.com/edrs.civil/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 rounded-full bg-blue-600 hover:bg-blue-700 flex items-center justify-center text-white text-2xl transition shadow-lg"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>

                <a
                  href="https://www.linkedin.com/in/narenthkumar-m-rebar-estimator-54711112b"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 rounded-full bg-sky-600 hover:bg-sky-700 flex items-center justify-center text-white text-2xl transition shadow-lg"
                >
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>

              </div>

            </div>

            {/* ================= FORM ================= */}

            <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 p-10">

              <div className="mb-8">

                <span className="uppercase tracking-[4px] text-amber-500 font-semibold">
                  Free Consultation
                </span>

                <h3 className="text-3xl font-bold text-slate-900 mt-3">
                  Request a Free Quote
                </h3>

                <p className="text-gray-500 mt-3">
                  Fill in your details and we'll contact you shortly.
                </p>

              </div>

              {/* Keep your existing form here */}
              <form onSubmit={handleSubmit} className="space-y-4">

                {submitted && (
                  <div className="bg-green-100 border border-green-300 text-green-700 rounded-lg p-3 text-sm">
                    ✅ Thank you! Your message has been sent successfully.
                  </div>
                )}

                {errorMsg && (
                  <div className="bg-red-100 border border-red-300 text-red-700 rounded-lg p-3 text-sm">
                    {errorMsg}
                  </div>
                )}

                {/* Name */}

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Full Name
                  </label>

                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your full name"
                    value={form.name}
                    onChange={handleChange}
                    className={`w-full px-4 py-3 rounded-lg border transition focus:outline-none focus:ring-2 focus:ring-amber-500 ${errors.name ? "border-red-500" : "border-gray-300"
                      }`}
                  />

                  {errors.name && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.name}
                    </p>
                  )}
                </div>

                {/* Phone */}

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Phone Number
                  </label>

                  <input
                    type="tel"
                    name="phone"
                    placeholder="Enter your phone number"
                    value={form.phone}
                    onChange={handleChange}
                    className={`w-full px-4 py-3 rounded-lg border transition focus:outline-none focus:ring-2 focus:ring-amber-500 ${errors.phone ? "border-red-500" : "border-gray-300"
                      }`}
                  />

                  {errors.phone && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.phone}
                    </p>
                  )}
                </div>

                {/* Email */}

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Email Address
                  </label>

                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={form.email}
                    onChange={handleChange}
                    className={`w-full px-4 py-3 rounded-lg border transition focus:outline-none focus:ring-2 focus:ring-amber-500 ${errors.email ? "border-red-500" : "border-gray-300"
                      }`}
                  />

                  {errors.email && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.email}
                    </p>
                  )}
                </div>

                {/* Message */}

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Project Details
                  </label>

                  <textarea
                    rows="4"
                    name="message"
                    placeholder="Tell us about your project..."
                    value={form.message}
                    onChange={handleChange}
                    className={`w-full px-4 py-3 rounded-lg border resize-none transition focus:outline-none focus:ring-2 focus:ring-amber-500 ${errors.message ? "border-red-500" : "border-gray-300"
                      }`}
                  ></textarea>

                  {errors.message && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.message}
                    </p>
                  )}
                </div>

                {/* Button */}

                <button
                  type="submit"
                  className="w-full bg-amber-500 hover:bg-amber-600 text-white py-3 rounded-lg font-semibold shadow-md hover:shadow-lg transition"
                >
                  Send Message
                </button>

              </form>

            </div>

          </div>

        </div>

      </section>



      {/* ================= FLOATING SOCIAL ICONS ================= */}



    </div>


  );
}
